import * as Actions from "../redux/creatorSession";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as UserActions from "../redux/userSession";

import { call, put, select, takeLatest } from "redux-saga/effects";

import { isValidUUID } from "../../utils/helpers";

export function* loadOrganizations({ payload }) {
  try {
    let organizationODM = yield call(OmniDataAPI.getAllOrganizations, payload);
    yield put(Actions.loadOrganizationsSuccess(organizationODM));
  } catch (error) {
    yield put(Actions.creatorSessionRequestFail(error));
  }
}

export function* updateOrganization({ payload }) {
  try {
    //payload is organizationODM

    const currentList = yield select(Actions.organizationODMsSelector);

    if (payload._id == null) {
      //CREATE
      let newOrganization = yield call(OmniDataAPI.createOrganization, payload);
      if (newOrganization == null) {
        yield put(Actions.creatorSessionRequestFail("OmniDataAPI.createOrganization FAILED"));
      } else {
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id); //creates a copy of the list
        newList.push(newOrganization);
        yield put(Actions.updateOrganizationSuccess(newList));
      }
    } else if (isValidUUID(payload._id)) {
      // UPDATE
      let newOrganization = yield call(OmniDataAPI.updateOrganization, payload);
      if (newOrganization == null) {
        yield put(Actions.creatorSessionRequestFail("OmniDataAPI.updateOrganization FAILED"));
      } else {
        const newList =
          currentList == null ? [] : currentList.filter(obj => obj._id !== payload._id);
        newList.push(newOrganization);
        yield put(Actions.updateOrganizationSuccess(newList));

        yield put(UserActions.reflectUpdatedOrganizationODMRequest(newOrganization));
      }
    } else {
      yield put(Actions.creatorSessionRequestFail("Bad organizationODM"));
    }
  } catch (error) {
    yield put(Actions.creatorSessionRequestFail(error));
  }
}

export function* deleteOrganization({ payload }) {
  try {
    if (isValidUUID(payload)) {
      const organizations = yield select(Actions.organizationODMsSelector);
      const newOrganizations =
        organizations == null ? [] : organizations.filter(obj => obj._id !== payload);
      let organization = yield call(OmniDataAPI.deleteOrganization, payload);
      if (organization != null) {
        yield put(Actions.deleteOrganizationSuccess(newOrganizations));
      } else {
        yield put(Actions.creatorSessionRequestFail("Bad organizationODM"));
      }
    }

    yield put(Actions.creatorSessionRequestFail("deleteOrganization: invalid UUID()"));
  } catch (error) {
    yield put(Actions.creatorSessionRequestFail(error));
  }
}

export function* setSelectedOrganization({ payload }) {
  try {
    //Validate Object
    yield put(Actions.setSelectedOrganizationSuccess(payload));
  } catch (error) {
    yield put(Actions.creatorSessionRequestFail(error));
  }
}

//#endregion

//  saga
export default function* organizationDataSaga() {
  yield takeLatest(Actions.loadOrganizationsRequest, loadOrganizations);
  yield takeLatest(Actions.updateOrganizationRequest, updateOrganization);
  yield takeLatest(Actions.deleteOrganizationRequest, deleteOrganization);
  yield takeLatest(Actions.setSelectedOrganizationRequest, setSelectedOrganization);
}
